import React from 'react';
import classnames from 'classnames';
import './Bullet.scss';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

const Bullet = props => {
  return (
    <li className={classnames('bulletCmp', props.className)}>
      <FlexContainer row noWrap>
        <div>{props.bulletCharacter}</div>
        <div
          data-testid={props.datatestid}
          className={classnames(props.textClass)}
        >
          {props.children}
        </div>
      </FlexContainer>
    </li>
  );
};

Bullet.defaultProps = {
  bulletCharacter: <>&#9679;</>,
  textClass: 'padL8',
};

export default Bullet;
